import {
	deleteGuestBankAccount,
	BankAccountSchema,
	BankAccountList,
} from "@/api/bank-accounts";
import { bankAccountKeys } from "./keys";
import { useMutation, QueryClient } from "@tanstack/react-query";
import { RequestError } from "@/axios/schema.ts";
import { useToast } from "@/components/ui/use-toast";

export default function useDeleteBankAccount({
	userId,
	locationId,
	queryClient,
	refetchBankAccounts,
}: {
	userId: number;
	locationId: number;
	queryClient: QueryClient;
	refetchBankAccounts: () => void;
}) {
	const { toast } = useToast();

	return useMutation({
		mutationFn: ({ bankAccountId }: { bankAccountId: number }) =>
			deleteGuestBankAccount({ guestId: userId, bankAccountId, locationId }),
		onSuccess: (data, variables) => {
			const deletedAccount = BankAccountSchema.safeParse(data);
			if (deletedAccount.success) {
				queryClient.setQueryData(
					bankAccountKeys.list({ guestId: userId, locationId }),
					(oldData: BankAccountList) => {
						if (!oldData) return oldData;
						return oldData.filter(
							(account) => account.id !== variables.bankAccountId,
						);
					},
				);
			} else {
				refetchBankAccounts();
			}
			toast({
				title: "Bank Account Deleted Successfully",
				description: "",
			});
		},
		onError: (error: RequestError) => {
			toast({
				title: "Deletion Failed",
				description: error.message,
				variant: "destructive",
			});
		},
	});
}
